export default __webpack_public_path__ + "static/media/IMG_0004.3692a7a7.jpeg";